module.exports = __webpack_public_path__ + "img/apple.5eeee1b5.jpg";